exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@media (max-width:600px){.mobile[data-v-51b46211]{display:none!important}}", "", {"version":3,"sources":["/opt/build/repo/src/pages/page-home.vue"],"names":[],"mappings":"AACA,yBACA,yBACI,sBAAyB,CAC5B,CACA","file":"page-home.vue","sourcesContent":["\n@media (max-width: 600px) {\n.mobile[data-v-51b46211] {\n    display: none !important;\n}\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-51b46211","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/opt/build/repo/src/stylesheets/variables.scss","/opt/build/repo/src/stylesheets/mixins.scss","/opt/build/repo/src/stylesheets/fonts.scss","/opt/build/repo/src/stylesheets/functions.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/page-home.vue
// module id = 588
// module chunks = 0